import { Component, Input, Output, EventEmitter, HostListener, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '../button/button.component';

/**
 * Interfaz para la llamada a un método con parámetros
 */
interface MethodCallWithParams {
    /** Nombre del método a ejecutar */
    methodName: string;
    /** Parámetros para el método */
    params?: any[];
}

@Component({
    selector: 'app-partners-recommended-modal',
    templateUrl: './partners-recommended-modal.component.html',
    styleUrls: ['./partners-recommended-modal.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        TranslateModule,
        ButtonComponent
    ]
})
export class PartnersRecommendedModalComponent {
    @Input() open = false;
    @Output() openChange = new EventEmitter<boolean>();
    @Output() confirmed = new EventEmitter<void>();
    @ViewChild('closeBtn') closeBtn!: ElementRef<HTMLButtonElement>;
    private previouslyFocused?: HTMLElement;

    constructor(private renderer: Renderer2, private host: ElementRef<HTMLElement>) {}

    ngOnInit(): void {
        if (this.open) this.onOpen();
    }

    ngOnDestroy(): void {
        this.enableScroll();
    }

    ngOnChanges?(): void {
        if (this.open) this.onOpen();
        else this.onClose();
    }

    openModal(): void {
        this.open = true;
        this.openChange.emit(this.open);
        this.onOpen();
    }

    closeModal(): void {
        this.open = false;
        this.openChange.emit(this.open);
        this.onClose();
    }

    confirm(): void {
        this.confirmed.emit();
        this.closeModal();
    }

    private onOpen(): void {
        this.previouslyFocused = document.activeElement as HTMLElement;
        this.disableScroll();
        setTimeout(() => this.closeBtn?.nativeElement?.focus(), 0);
    }

    private onClose(): void {
        this.enableScroll();
        if (this.previouslyFocused) this.previouslyFocused.focus();
    }

    private disableScroll(): void {
        this.renderer.addClass(document.body, 'modal-open');
    }

    private enableScroll(): void {
        this.renderer.removeClass(document.body, 'modal-open');
    }

    @HostListener('document:keydown.escape', ['$event'])
    onEscape(event: KeyboardEvent) {
        if (this.open) {
        event.preventDefault();
        this.closeModal();
        }
    }

    onBackdropClick(e: MouseEvent) {
        if ((e.target as HTMLElement).classList.contains('modal-backdrop')) {
        this.closeModal();
        }
    }
}
